import WithRender from "../../templates/layouts/layoutUploadFullPageConfiguration.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getIsCimpressProduct"])
  }
});
